module.exports = __webpack_public_path__ + "img/powered3.b900d5c1.png";